import { IIndexable } from "types/common";
import { FaUserClock } from "react-icons/fa";
import {
  AiOutlineInfoCircle,
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
} from "react-icons/ai";

export const alertTypeIconMapping: IIndexable = {
  info: AiOutlineInfoCircle,
  success: AiOutlineCheckCircle,
  danger: AiOutlineCloseCircle,
  warning: FaUserClock,
};

export const alertTypeColorMapping: IIndexable = {
  info: {
    bg: "#EBF8FF",
    color: "#3182CE",
    _dark: {
      bg: "#3182ce80",
      color: "#FFFFFF",
    },
  },
  success: {
    bg: "#F1FFF7",
    color: "#206846",
    _dark: {
      bg: "#F1FFF780",
      color: "#206846",
    },
  },
  danger: {
    bg: "#FFF5F5",
    color: "#E53E3E",
    _dark: {
      bg: "#c5303080",
      color: "#FFFFFF",
    },
  },
  warning: {
    bg: "#FFFFF0",
    color: "#ECC94B",
    _dark: {
      bg: "#ecc94b80",
      color: "#FFFFFF",
    },
  },
};
